module.exports = __webpack_public_path__ + "img/dice-four.ee265778.svg";